import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  bulkUpsertNotificationEventTypes,
  deleteNotificationEventType,
  getNotificationEventTypes,
  updateNotificationEventType,
} from './notification-event-types.api';
import type {
  BulkUpsertNotificationEventTypeValues,
  UpdateNotificationEventTypeValues,
} from './notification-event-types.types';

const EVENT_TYPES_KEY = ['notification-event-types'];

export const useNotificationEventTypesQuery = () =>
  useQuery({
    queryKey: EVENT_TYPES_KEY,
    queryFn: () => getNotificationEventTypes(),
  });

export const useUpdateNotificationEventTypeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (values: UpdateNotificationEventTypeValues) => updateNotificationEventType(values),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: EVENT_TYPES_KEY });
    },
  });
};

export const useBulkUpsertNotificationEventTypesMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (values: BulkUpsertNotificationEventTypeValues) =>
      bulkUpsertNotificationEventTypes(values),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: EVENT_TYPES_KEY });
    },
  });
};

export const useDeleteNotificationEventTypeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ eventType }: { eventType: string }) => deleteNotificationEventType(eventType),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: EVENT_TYPES_KEY });
    },
  });
};
